import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* React Router */
import { withRouter } from 'react-router-dom';

/* Result */
import Result from 'iotera-base/result';

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks';
import { actions as notificationActions } from '../../redux/ducks/notification';

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes';

/* Object Json */
import {
  safeGetWithType,
  parseAny,
  stringify,
  clean,
  safeGet,
} from 'iotera-base/json';
import { _N, isEmpty } from 'iotera-base/object';

import { IoteraForm } from '../../lib/components/form';
import { SubViewHeader } from '../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { AreaInput, TextInput } from '../../lib/components/textInput';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../lib/components/callbackGlobal';

const CREATE = 'CREATE';
const UPDATE = 'UPDATE';
const WKEY = 'CREDENTIALS_CREATE_UPDATE';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const buildSchema = isCreate => {
  const schema = {
    definitions: {
      Category: {
        title: 'Category',
        type: 'number',
        anyOf: [
          {
            type: 'number',
            enum: [21],
            title: 'API_KEY',
          },
          {
            type: 'number',
            enum: [14],
            title: 'OPEN_V4',
          },
          {
            type: 'number',
            enum: [19],
            title: 'OPEN_V0',
          },
          {
            type: 'number',
            enum: [31],
            title: 'OIDC',
          },
        ],
      },
    },
    type: 'object',
    required: ['category', 'credentials_id', 'scopes', 'details'],
    properties: {
      category: {
        $ref: '#/definitions/Category',
        title: 'Category',
      },
      credentials_id: {
        type: 'string',
        title: 'Credentials Id',
        maxLength: 32,
      },
      credentials_secret: {
        type: 'string',
        title: 'Credentials Secret',
        maxLength: 256,
      },
      scopes: { type: 'string', title: 'Scopes', default: '{}' },
      details: { type: 'string', title: 'Details', default: '{}' },
    },
  };

  if (!isCreate) {
    schema['properties']['scopes'] = {
      type: 'string',
      title: 'Scopes',
    };
    schema['properties']['details'] = { type: 'string', title: 'Details' };
  }

  return schema;
};

const buildUiSchema = isCreate => {
  const uiSchema = {
    credentials_id: {
      'ui:widget': props => {
        return (
          <TextInput
            id="credentials_id"
            type="text"
            label="Credentials Id"
            placeholder="Credentials Id"
            textTooltip="Credentials Id"
            className="custom"
            value={props.value}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
          />
        );
      },
      'ui:options': {
        label: false,
      },
    },
    credentials_secret: {
      'ui:disabled': true,
    },
    scopes: {
      'ui:widget': props => {
        return (
          <AreaInput
            id="scopes"
            type="text"
            label="Scopes"
            textTooltip="Scopes"
            value={props.value}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
            areaHeight={200}
            {...props}
          />
        );
      },
      'ui:options': {
        label: false,
      },
    },
    details: {
      'ui:widget': props => {
        return (
          <AreaInput
            id="details"
            type="text"
            label="Details"
            textTooltip="Details"
            value={props.value}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
            areaHeight={200}
            {...props}
          />
        );
      },
      'ui:options': {
        label: false,
      },
    },
  };

  if (!isCreate) {
    uiSchema['category'] = {
      'ui:disabled': true,
    };
    uiSchema['credentials_id'] = {
      'ui:disabled': true,
    };
  }
  return uiSchema;
};

class CredentialsCreateUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      formData: {},
    };
    this.isTenant = dit(props);
    this.domain = domain(props);

    this.id = safeGet(props, ['match', 'params', 'id']);
    this.isCreate = _N(this.id);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.schema = buildSchema(this.isCreate);
    this.uiSchema = buildUiSchema(this.isCreate);
  }

  componentDidMount() {
    const self = this;
    const props = this.props;

    // Callback Global
    setCallbackGlobal(props);

    if (!this.isCreate) {
      props.wInitRequestCall({
        wparam: {
          ...self.isTenant,
          path: '/service/web/credentials/read?id=' + this.id,
        },
        wreducer: {
          rparse: function (id, rparse, rpayload) {
            let item = {};
            let credentials = rpayload;
            item.id = safeGetWithType(credentials, 'id', '');
            item.category = safeGetWithType(credentials, 'category', 19);
            item.credentials_id = safeGetWithType(
              credentials,
              'credentials_id',
              '',
            );
            item.credentials_secret = safeGetWithType(
              credentials,
              'credentials_secret',
              '',
            );
            item.scopes = stringify(
              safeGetWithType(credentials, 'scopes', {}),
            );
            item.details = stringify(
              safeGetWithType(credentials, 'details', {}),
            );
            clean(item);
            self.setState({ loading: false, formData: { ...item } });
            return item;
          },
        },
      });
    }

    props.wSetConfig({
      single_config: {
        [CREATE]: {
          wparam: {
            ...this.isTenant,
            method: 'POST',
            path: '/service/web/credentials/create',
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR,
                );
                if (responseResult === Result.SUCCESS) {
                  self.setState({ loading: false });
                  // Magic to refresh routes
                  props.history.push('..');
                  props.history.push(
                    '..' + S + self.domain + S + '@credentials',
                  );
                  props.showSingleNotification({
                    message: 'Create credentials suceess',
                    level: 'success',
                  });
                  return;
                }
              }
              self.setState({ loading: false });
              props.showSingleNotification({
                message: 'Create credentials failed',
                level: 'error',
              });
            },
          },
        },
        [UPDATE]: {
          wparam: {
            ...this.isTenant,
            method: 'POST',
            path: '/service/web/credentials/update',
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR,
                );
                if (responseResult === Result.SUCCESS) {
                  self.setState({ loading: false });
                  // Magic to refresh routes
                  props.history.push('..');
                  props.history.push(
                    '../..' + S + self.domain + S + '@credentials',
                  );
                  props.showSingleNotification({
                    message: 'Update credentials success',
                    level: 'success',
                  });
                  return;
                }
              }
              self.setState({ loading: false });
              props.showSingleNotification({
                message: 'Update credentials failed',
                level: 'error',
              });
            },
          },
        },
      },
    });
  }

  componentWillUnmount() {
    const props = this.props;

    // Callback global
    unsetCallbackGlobal(props);
    props.wUnsetConfig({ key: WKEY });
  }

  back() {
    const link = (this.isCreate ? '..' : '../..') + S + '@credentials';
    this.props.history.push(link);
  }

  handleChange(event) {
    this.setState({ formData: event.formData });
  }

  handleSubmit(event) {
    const props = this.props;
    const state = this.state;

    const formData = safeGet(state, 'formData');
    const category = safeGetWithType(formData, 'category', 19);
    const credentialsId = safeGetWithType(formData, 'credentials_id', '');
    const scopes = safeGetWithType(formData, 'scopes', '');
    const scopesParsed = parseAny(scopes);
    const details = safeGetWithType(formData, 'details', '');
    const detailsParsed = parseAny(details);

    if (_N(scopesParsed)) {
      props.showSingleNotification({
        message: 'Invalid JSON for `Scopes`',
        level: 'warning',
      });
      return;
    }

    if (_N(detailsParsed)) {
      props.showSingleNotification({
        message: 'Invalid JSON for `Details`',
        level: 'warning',
      });
      return;
    }

    const body = {
      scopes: scopesParsed,
      details: detailsParsed,
    };
    if (this.isCreate) {
      body['category'] = category;
      body['credentials_id'] = credentialsId;
    } else {
      body['id'] = this.id;
    }

    this.setState({ loading: true });
    props.wSingleRequestCall({
      id: this.isCreate ? CREATE : UPDATE,
      body,
    });
  }

  render() {
    const props = this.props;
    const state = this.state;
    const { loading, formData } = state;
    let shouldRenderForm = true;

    let shownFormData = formData;
    if (!this.isCreate) {
      const item = safeGetWithType(props, 'item', {});
      shownFormData = item;
      shouldRenderForm = !isEmpty(shownFormData);
    }

    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="bubbles" color="#000" />
      </div>
    );

    let formTitle = 'Create Credentials';
    let formSubtitle = 'Create Credentials Form';
    if (!this.isCreate) {
      formTitle = 'Update Credentials';
      formSubtitle = 'Update Credentials Form';
    }

    return (
      <Loader
        show={loading}
        message={spinner}
        backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}
      >
        <div className="view">
          <SubViewHeader title={formTitle} subTitle={formSubtitle} />
          <div className="io-container mt-12">
            {shouldRenderForm && (
              <IoteraForm
                schema={this.schema}
                uiSchema={this.uiSchema}
                formData={shownFormData}
                onChange={this.handleChange}
                onSubmit={this.handleSubmit}
              >
                <div className="button-right">
                  <Button
                    variant="outlined"
                    type="button"
                    size="large"
                    style={{ minWidth: '0%' }}
                    onClick={e => this.back()}
                  >
                    Batal
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}
                  >
                    Simpan
                  </Button>
                </div>
              </IoteraForm>
            )}
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  if (!this.isCreate) {
    return {
      item: wSelector.getSoleInitMappedRPayload(state),
    };
  }
  return null;
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CredentialsCreateUpdate));
